module.exports = __webpack_public_path__ + "static/img/file_kotlin.f7af407a.png";